import {
  arrayOf,
  customType,
  params,
  shape,
  string
} from '@thd-nucleus/data-sources';
import { ANCHOR_TYPE, CUSTOMER_TYPE, PAGE_TYPE } from './constants';

export const dataModel = {
  suggestedQuestions: params({
    request: customType('SuggestedQuestionsRequest').shape({
      application: string(),
      pageType: customType('PageType').enum(Object.values(PAGE_TYPE), PAGE_TYPE.PLP),
      customerType: customType('CustomerType')
        .enum(Object.values(CUSTOMER_TYPE), CUSTOMER_TYPE.B2C),
      anchors: arrayOf(
        customType('AnchorInput').shape({
          type: customType('AnchorType')
            .enum(Object.values(ANCHOR_TYPE), ANCHOR_TYPE.SEARCH_TERM),
          value: string()
        })
      )
    }).isRequired()
  }).shape({
    results: arrayOf(
      shape({
        anchor: shape({
          value: string()
        }),
        stacks: arrayOf(
          shape({
            strategyGroups: arrayOf(
              shape({
                summaries: arrayOf(
                  shape({
                    type: string(),
                    title: string(),
                    body: string()
                  })
                ),
                strategies: arrayOf(
                  shape({
                    questions: arrayOf(
                      shape({
                        question: string()
                      })
                    )
                  })
                )
              })
            )
          })
        )
      })
    )
  })
};
